/**
 * @generated SignedSource<<dc2e570063225c870eb27aa756868a50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pantoneLibraryPageImportDefaultPaletteMutation$variables = {
  id: string;
};
export type pantoneLibraryPageImportDefaultPaletteMutation$data = {
  readonly importDefaultPalette: string;
};
export type pantoneLibraryPageImportDefaultPaletteMutation = {
  response: pantoneLibraryPageImportDefaultPaletteMutation$data;
  variables: pantoneLibraryPageImportDefaultPaletteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "importDefaultPalette",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa7d6ee60085364e86a76ec72be437c1",
    "id": null,
    "metadata": {},
    "name": "pantoneLibraryPageImportDefaultPaletteMutation",
    "operationKind": "mutation",
    "text": "mutation pantoneLibraryPageImportDefaultPaletteMutation(\n  $id: ID!\n) {\n  importDefaultPalette(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b27cb8b55b263caba57c5e9749898e64";

export default node;
